/* unplugin-vue-components disabled */import { render } from "./DeviceMac.vue?vue&type=template&id=4942b08f&scoped=true"
import script from "./DeviceMac.vue?vue&type=script&lang=js"
export * from "./DeviceMac.vue?vue&type=script&lang=js"

import "./DeviceMac.vue?vue&type=style&index=0&id=4942b08f&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4942b08f"]])

export default __exports__